<template>
  <div class="rankinfo">
    <span v-if="showMobile">
      <div :class="[wwClassMobile, 'rankinfo__box', 'rankinfo__box--mobile']">
        <TooltipHelper :toolkey="toolkey">
          <template v-slot:toolTipText>
            <h4 class="text-white">{{ ww }}%</h4>
          </template>
        </TooltipHelper>
      </div>
    </span>
    <span v-if="!showMobile" class="rankinfo__stack">
      <div :class="[wwClass, 'rankinfo__box']">
        <h2 class="text-white rankinfo__num">#{{ tarif.rank }}</h2>
      </div>
      <div class="blackground rankinfo__box">
        <TooltipHelper :toolkey="toolkey">
          <template v-slot:toolTipText>
            <h3 class="text-white rankinfo__num">{{ ww }}%</h3>
          </template>
        </TooltipHelper>
      </div>
    </span>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, defineProps } from "vue";
  import TooltipHelper from "@/components/base/TooltipHelper.vue";
  //   import { useBerechnungStore } from "@/stores/berechnung";
  //   import { useSharedDataStore } from "@/stores/sharedData";
  //   const sharedDataStore = useSharedDataStore();
  //   const berechnungStore = useBerechnungStore();

  const props = defineProps({
    showMobile: {
      type: Boolean,
    },
    tarif: {
      type: Object,
      default: () => ({}),
    },
    berechnung: {
      type: Object,
      default: () => ({}),
    },
  });

  const wwClassMobile = ref(false);
  const wwClass = ref(false);

  const toolkey = computed(() => {
    if (
      props.berechnung.ber_segment <= 1 &&
      props.berechnung.ber_algo_view != 2
    ) {
      return "tarif_waizmannwert";
    } else if (
      props.berechnung.ber_segment <= 1 &&
      props.berechnung.ber_algo_view == 2
    ) {
      return "tarif_kwert_gesamt";
    } else if (props.berechnung.ber_segment == 2) {
      return "bri_ww";
    } else if (props.berechnung.ber_segment == 3) {
      return "hp_gesamterstattung_2_4";
    } else if (props.berechnung.ber_segment == 4) {
      return "kh_ww";
    }
    return 0; // Standardfall, wenn keine anderen Bedingungen erfüllt sind
  });
  const ww = computed(() => {
    if (
      props.berechnung.ber_segment <= 1 &&
      props.berechnung.ber_algo_view != 2
    ) {
      return Math.round(props.tarif.tarif_waizmannwert || 0);
    } else if (
      props.berechnung.ber_segment <= 1 &&
      props.berechnung.ber_algo_view == 2
    ) {
      return Math.round(props.tarif.tarif_kwert_gesamt || 0);
    } else if (props.berechnung.ber_segment == 2) {
      return Math.round(props.tarif.bri_ww || 0);
    } else if (props.berechnung.ber_segment == 3) {
      return Math.round(props.tarif.hp_gesamterstattung_2_4 || 0);
    } else if (props.berechnung.ber_segment == 4) {
      return Math.round(props.tarif.kh_ww || 0);
    }
    return 0; // Standardfall, wenn keine anderen Bedingungen erfüllt sind
  });
  onMounted(() => {
    if (props.tarif.empfehlung_type > 0) {
      wwClassMobile.value = props.berechnung.empRankBest;
      wwClass.value = props.berechnung.empRankBest;
    } else {
      wwClassMobile.value = props.berechnung.empRankBase;
      wwClass.value = props.berechnung.empRankBase;
    }
  });
  console.log(props.tarif);
</script>

<style scoped>
  .rankinfo__stack {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
  .rankinfo__box {
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 0;
    box-sizing: border-box;
  }
  .rankinfo__box--mobile {
    width: 48px;
    height: 48px;
  }
  .rankinfo__box > :deep(*) {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .rankinfo__box :deep(span) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .rankinfo__num {
    margin: 0;
    font-size: 20px;
    line-height: 1;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    text-align: center;
    white-space: nowrap;
  }
</style>
